import React, {useRef, useState} from 'react';
import clsx from 'clsx';

import {Typography} from '@nur-portal/ui-kit';

import {getIconUrl} from '../../../services/content-type/share-modal';
import {getShareUrl, LIST_SHARE_NETWORKS} from '../../../website-ui/components/share-menu';
import useOnClickOutside from '../../../website-ui/hooks/use-click-outside';

import styles from './index.module.css';

const ShareMenuModal = ({onClose}) => {
  const ref = useRef();

  useOnClickOutside(ref, onClose);
  const utmMedium = 'golos-naroda-share-bio';
  const title = document.title;
  const url = window.location.href;
  const onCopyLinkClick = e => {
    const $target = e.currentTarget;

    import(/* webpackChunkName: "copy-to-clipboard" */ '../../../services/content-type/copy-to-clipboard')
      .then(module => {
        module.default(window.location.href, $target, 'trend-link');
      });
  };

  return (
    <div className={styles.modalContainer} ref={ref}>
      <div className={styles.modalTop}>
        <Typography variant="title-18">
          Поделиться:
        </Typography>
        <img alt="close" src={getIconUrl('icons/close-golos')} className={styles.closeIcon} onClick={onClose} />
      </div>
      <ul className={styles.list}>
        <li className={styles.item} onClick={onCopyLinkClick}>
          <img
            className={styles.itemImage}
            src={getIconUrl('social-icons/new/copy-link')}
            alt="copy"
          />
          Копировать ссылку
        </li>
        {LIST_SHARE_NETWORKS.map(item => {
          const shareUrl = getShareUrl({...item, url, utmMedium, title});
          const imageUrl = item.imageUrl.default;

          return (
            <li className={styles.item} key={item.name}>
              <a
                href={shareUrl}
                rel="nofollow noopener noreferrer"
                target="_blank"
                className={styles.itemLink}
              >
                <img src={imageUrl} alt={item.name} className={styles.itemImage} />
                {item.name}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

const ShareMenu = ({className}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const classNames = clsx({
    [styles.container]: true,
    [className]: Boolean(className)
  });
  const onButtonClick = () => {
    if (navigator.share) {
      const trackingUrl = new URL(window.location.href);

      trackingUrl.searchParams.append('utm_source', 'web-share-api');

      navigator.share({title: document.title, url: trackingUrl.toString()}).catch(console.error);
    } else {
      setModalOpen(true);
    }
  };
  const onCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <div className={classNames}>
      <button className={styles.button} onClick={onButtonClick}>
        <img className={styles.buttonIcon} src={getIconUrl('icons/share')} alt="share" />
        Поделиться страницей номинанта
      </button>
      {modalOpen && <ShareMenuModal onClose={onCloseModal} />}
    </div>
  );
};

export {ShareMenu};
